import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => {
    const tabletBreakpoint = getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET);
    const desktopBreakpoint = getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP);
    const tabletOrDesktopBreakpoint = getThemeBreakpointByDeviceType(theme, EDeviceType.TABLET_OR_DESKTOP);

    return {
        cardError: {
            border: `1.5px solid ${theme.palette.error.main}`,
            borderRadius: theme.shape.borderRadius,
        },
        container: {
            padding: theme.spacing(5, 4),
        },
        form: {
            padding: 0,
        },
        accountTypeColumn: {
            display: "flex",
            flexDirection: "column",
            "& .payment-type-field": {
                width: "100%",
            },
        },
        containerFields: {
            padding: theme.spacing(1.25, 0),
        },
        dateTimeRow: {
            marginTop: theme.spacing(1),
            [tabletBreakpoint]: {
                marginTop: theme.spacing(2),
            },
            [desktopBreakpoint]: {
                marginTop: theme.spacing(2),
            },
        },
        preferredTime: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        accountRow: {
            marginTop: theme.spacing(2),
        },
        submitSection: {
            paddingTop: theme.spacing(2.5),
        },
        cancelButton: {
            "&&": {
                padding: "8px 22px",
            },
        },
        submitGrid: {
            justifyContent: "center",
            [tabletBreakpoint]: {
                justifyContent: "flex-end",
            },
            [desktopBreakpoint]: {
                justifyContent: "flex-end",
            },
        },
        portInInfo: {
            fontWeight: theme.typography.fontWeightBold,
        },
        checkedDetailsValue: {
            fontWeight: theme.typography.fontWeightRegular,
        },
        eSimSubmitGridItem: {
            paddingTop: theme.spacing(1.25),
        },
        eSimSubmitStack: {
            justifyContent: "center",
            [tabletOrDesktopBreakpoint]: {
                justifyContent: "flex-end",
            },
        },
        eSimIcon: {
            alignSelf: "center",
            justifySelf: "center",
            "& img": {
                margin: theme.spacing(1.25),
                height: 58,
            },
        },
        eSimOtherDescription: {
            backgroundColor: theme.palette.background.default,
        },
        eSimHelpIcon: {
            display: "flex",
            alignItems: "center",
            marginTop: theme.spacing(4),
        },
    };
});
